import React from "react";
//Cookie token
import cookie from "react-cookies";
//Router redirect
import { useHistory } from "react-router-dom";

const OrderManualCheck = () => {
  //Redirect if not logged in
  let history = useHistory();
  const token = cookie.load("usertk");

  return (
    <>
      {!token ? (
        history.push("/")
      ) : (
        <>
          <h1>Comprobar pedido asignado manualmente</h1>
          <h1>Comprobar pedido asignado manualmente</h1>
          <h1>Comprobar pedido asignado manualmente</h1>
          <h1>Comprobar pedido asignado manualmente</h1>
          <h1>Comprobar pedido asignado manualmente</h1>
          <h1>Comprobar pedido asignado manualmente</h1>
          <h1>Comprobar pedido asignado manualmente</h1>
          <h1>Comprobar pedido asignado manualmente</h1>
          <h1>Comprobar pedido asignado manualmente</h1>
          <h1>Comprobar pedido asignado manualmente</h1>
          <h1>Comprobar pedido asignado manualmente</h1>
          <h1>Comprobar pedido asignado manualmente</h1>
        </>
      )}
    </>
  );
};

export default OrderManualCheck;
